export default "__VITE_ASSET__DShdh0Ur__"